import { ForwardedRef, forwardRef, memo } from 'react'
import { FormValueInput } from 'types'
import { createSkillGroups, mergeSkillGroups, SkillEntry, SkillInputValueItem } from 'services/jobSkills'
import SkillsInput, { ISkillsInputProps } from './SkillsInput'

export interface ISkillsInputWrapperProps extends Omit<ISkillsInputProps, 'input'> {
  input: FormValueInput<SkillInputValueItem[]>
}

const SkillsInputWrapper = (props: ISkillsInputWrapperProps, ref: ForwardedRef<HTMLInputElement>) => {
  // this component takes care of handling the 'requiredSkills' prop (in both directions)
  // it also does the conversion from group-indexed alt sets to skill-contained alternatives

  const { input, requiredSkills, ...restProps } = props
  const valueIn = mergeSkillGroups((input?.value || []).filter(skill => requiredSkills === (skill.required || false)))

  const handleChange = (value: SkillEntry[]) => {
    const prevSkills = input?.value || []

    value = value.filter(v => Boolean(v.skill_id)).map(skill => ({ ...skill, required: requiredSkills }))
    value = Array.from(createSkillGroups(value))

    input?.onChange([
      ...value,
      ...(prevSkills.filter(skill => skill.required !== requiredSkills)),
    ])
  }

  return (
    <SkillsInput
      ref={ref}
      requiredSkills={requiredSkills}
      input={{
        ...input,
        value: valueIn,
        onChange: handleChange,
      }}
      {...restProps}
    />
  )
}

export default memo(forwardRef<HTMLInputElement, ISkillsInputWrapperProps>(SkillsInputWrapper))
